import React, { useEffect, useState } from "react";
import { FaUser, FaPhone, FaEnvelope } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  EDIT_MANAGE_PROJECT_DETAILS,
  MANAGE_PROJECT,
} from "../../utils/RouteConstant";
import Breadcrumbs from "../../customComponent/BreadCrumbs";
import { breadcrumbNameMap, ImageBaseUrl } from "../../utils/helperData";
import { BiEdit } from "react-icons/bi";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { Tab } from "@headlessui/react";
import InspectionDetails from "./InspectionDetails";
import ReportAnalytics from "./ReportAnalytics";
import User_id from "../../../asesst/User_Id.svg";
import Project_Document from "../../../asesst/Project_Document.svg";
import { Box, Modal } from "@mui/material";
import { RxCrossCircled } from "react-icons/rx";
import Danger from "../../../asesst/Danger.svg";
import { IoCheckmarkDone } from "react-icons/io5";
import { GetProjectDetails, projectMarkasComplete } from "../../../redux/action/ProjectManagement/ProjectManagentAction";
import { useDispatch, useSelector } from "react-redux";
import { IoIosImages } from "react-icons/io";
import WeldingAnalytics from "./WeldingAnalytics";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ViewManageProjectDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [openSaveModal, setOpenSaveModal] = useState(false);

  const projectDetails = useSelector((state) => state.project.projectDetails);

  useEffect(() => {
    if (projectId) {
      dispatch(GetProjectDetails(projectId));
    }
  }, [projectId]);
  const [categories] = useState({
    "Inspection Details": [],
    "Welding Analytics": [],
    "Data Verification": [],
    "Project Details": [],
  });

  useEffect(() => {
    if (location.state?.selectedTab === "Inspection Details") {
      setSelectedTabIndex(0);
    }
  }, [location.state]);
  const handleEditProject = () => {
    if (projectId) {
      navigate(`${EDIT_MANAGE_PROJECT_DETAILS}/${projectId}`);
    }
  };
  const tabNames = [
    "Inspection Details",
    "Welding Analytics",
    "Data Verification",
    "Project Details",
  ];

  useEffect(() => {
    if (location.state && location.state.selectedTab) {
      const tabIndex = tabNames.indexOf(location.state.selectedTab);
      if (tabIndex !== -1) {
        setSelectedTabIndex(tabIndex);
      }
    }
  }, [location.state]);

  const openModal = () => {
    setOpenSaveModal(true);
  };

  const handleCloseSaveModal = () => {
    setOpenSaveModal(false);
  };

  const handleMarkAsCompleted = () => {
    dispatch(projectMarkasComplete(projectId));
    navigate(MANAGE_PROJECT);
    handleCloseSaveModal();
  };

  return (
    <div>
      <h2 className="text-3xl font-bold mb-6">Project Management</h2>
      <div className="flex justify-between items-center">
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
        {selectedTabIndex === 3 && (
          <div className="flex gap-8">
            {/* {projectDetails?.status !== 1 ? ( */}
            {Number(projectDetails?.status) !== 1 ? (
              <button
                onClick={openModal}
                className="bg-[#81D14E] text-white px-4 py-2 rounded-lg flex items-center hover:bg-[#84CC16]"
              >
                <IoCheckmarkDone className="mr-2" />
                Mark as Completed
              </button>
            ) : (
              <button
                onClick={openModal}
                className="bg-[#FB8787] text-white px-4 py-2 rounded-lg flex items-center hover:bg-[#84CC16]"
              >
                <IoCheckmarkDone className="mr-2" />
                Mark as Ongoing
              </button>
            )}
            <button
              onClick={handleEditProject}
              className="bg-[#1C3664] text-white px-4 py-2 rounded-lg flex items-center hover:bg-blue-900"
            >
              <BiEdit className="mr-2" />
              Edit Details
            </button>
          </div>
        )}
        {selectedTabIndex === 0 ||
        selectedTabIndex === 1 ||
        selectedTabIndex === 2 ? (
          <div className="flex gap-2 items-center">
            {projectDetails?.document && (
              <img
                src={`${ImageBaseUrl}${projectDetails.document}`}
                alt="not"
                className="preview-image w-[3.5rem] h-12 bg-cover bg-center rounded-3xl mr-2.5"
              />
            )}
            <span className="text-xl font-semibold">
              Project Name:-
              <span className="text-blue-500"> {projectDetails?.name}</span>
            </span>
          </div>
        ) : null}
      </div>

      <Tab.Group
        selectedIndex={selectedTabIndex}
        onChange={setSelectedTabIndex}
      >
        <Tab.List className="flex space-x-1 rounded-t-xl bg-blue-900/20 p-1 mt-4">
          {Object?.keys(categories).map((category) => (
            <Tab
              key={category}
              className={({ selected }) =>
                classNames(
                  "w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-blue-700",
                  "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                  selected
                    ? "bg-white shadow"
                    : "text-blue-100 hover:bg-white/[0.52] hover:text-black"
                )
              }
            >
              {category}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="mx-auto bg-white shadow-lg rounded-b-xl ">
          <Tab.Panel className="p-1">
            <InspectionDetails />
          </Tab.Panel>

          <Tab.Panel>
            <WeldingAnalytics />
          </Tab.Panel>

          <Tab.Panel>
            <ReportAnalytics />
          </Tab.Panel>
          <Tab.Panel className="p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
              <div>
                <div className="flex">
                  <div>
                    <FaUser className="text-[#1C3664] mr-3 mt-[1px]" />
                  </div>
                  <div className="text-base font-semibold text-[#1C3664]">
                    Client Name
                  </div>
                </div>
                <div className="text-base text-[#626262] font-light mt-3">
                  {projectDetails?.client_name}
                </div>
              </div>

              <div>
                <div className="flex">
                  <div>
                    <img
                      src={User_id}
                      alt="user_id"
                      className="mr-3 mt-[2px] h-5 w-5"
                    />
                    {/* <FaUser className="text-[#1C3664] mr-3 mt-[1px]" /> */}
                  </div>
                  <div className="text-base font-semibold text-[#1C3664]">
                    Client ID
                  </div>
                </div>
                <div className="text-base text-[#626262] font-light mt-3">
                  {projectDetails?.client_id}
                </div>
              </div>

              <div>
                <div className="flex">
                  <div>
                    <BusinessCenterIcon className="text-[#1C3664] mr-3 mt-[-6px]" />
                  </div>
                  <div className="text-base font-semibold text-[#1C3664]">
                    Project Name
                  </div>
                </div>
                <div className="text-base text-[#626262] font-light mt-3">
                  {projectDetails?.name}
                </div>
              </div>

              {projectDetails?.document && (
                <div>
                  <div className="flex">
                    <div>
                      <IoIosImages className="text-[#1C3664] mr-3 h-[22px] w-[22px]" />
                    </div>
                    <div className="text-base font-semibold text-[#1C3664]">
                      Project Image
                    </div>
                  </div>
                  <div className="text-base flex justify-between text-[#626262] font-light mt-2">
                    <div className="preview-container flex items-center gap-4 p-2 bg-slate-100 border border-solid rounded-lg">
                      <img
                        src={`${ImageBaseUrl}${projectDetails.document}`}
                        alt="not"
                        className="preview-image w-32 h-24 bg-cover bg-center rounded-md"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 mt-10 gap-6 mb-6">
              <div>
                <div className="flex">
                  <div>
                    <img
                      src={Project_Document}
                      alt="user_id"
                      className="mr-3 mt-[2px] h-5 w-5"
                    />
                    {/* <EditNoteIcon className="text-[#1C3664] font-extrabold mr-2" /> */}
                  </div>
                  <div className="text-base font-semibold text-[#1C3664]">
                    Project Description
                  </div>
                </div>
                <div className="text-base text-[#626262] font-light mt-3">
                  {projectDetails?.description}
                </div>
              </div>
            </div>
            {projectDetails?.inspectors_info?.length > 0 ? (
              <div className="mt-12">
                <h3 className="text-xl text-[#1C3664] font-semibold mb-2">
                  Inspector Details
                </h3>
                <div
                  style={{ borderBottom: "3px solid #1C3664", width: "4%" }}
                ></div>

                {projectDetails?.inspectors_info &&
                  projectDetails?.inspectors_info?.map((inspector, index) => (
                    <div
                      key={index}
                      className="grid mt-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6"
                    >
                      <div>
                        <div className="flex">
                          <div>
                            <FaUser className="text-[#1C3664] mr-3 mt-[1px]" />
                          </div>
                          <div className="text-base font-semibold text-[#1C3664]">
                            Inspector Name
                          </div>
                        </div>
                        <div className="text-base text-[#626262] font-light mt-3">
                          {inspector?.inspector_name}
                        </div>
                      </div>
                      <div>
                        <div className="flex">
                          <div>
                            <FaPhone className="text-[#1C3664] mr-3 mt-[1px]" />
                          </div>
                          <div className="text-base font-semibold text-[#1C3664]">
                            Phone Number
                          </div>
                        </div>
                        <div className="text-base text-[#626262] font-light mt-3">
                          {inspector?.mobile}
                        </div>
                      </div>

                      <div>
                        <div className="flex">
                          <div>
                            <FaEnvelope className="text-[#1C3664] mr-3 mt-[1px]" />
                          </div>
                          <div className="text-base font-semibold text-[#1C3664]">
                            Email
                          </div>
                        </div>
                        <div className="text-base text-[#626262] font-light mt-3">
                          {inspector?.email}
                        </div>
                      </div>
                      <div>
                        <div className="flex">
                          <div>
                            <img
                              src={User_id}
                              alt="user_id"
                              className="mr-3 mt-[2px] h-5 w-5"
                            />
                            {/* <FaUser className="text-[#1C3664] mr-3 mt-[1px]" /> */}
                          </div>
                          <div className="text-base font-semibold text-[#1C3664]">
                            Inspector ID
                          </div>
                        </div>
                        <div className="text-base text-[#626262] font-light mt-3">
                          {inspector?.employee_id}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            ) : (
              <p></p>
            )}
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>

      <Modal open={openSaveModal} className="justify-center items-center">
        <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
          <RxCrossCircled
            onClick={handleCloseSaveModal}
            className="float-end top-2 h-6 w-6 cursor-pointer"
          />
          <div className="text-center inline-flex mt-4">
            <div className="flex items-center justify-center">
              <img src={Danger} alt="Logout" />
            </div>
          </div>
          <p className="text-2xl text-[#0B0B0B] font-semibold mt-4 mb-2">
            Mark as Completed
          </p>
          <span className="text-[#6D6D6D] font-light text-lg">
            Are you sure you want to mark this project as completed ?
          </span>
          <div className="mt-6 flex justify-center gap-4">
            <button
              onClick={handleMarkAsCompleted}
              className="bg-gray-300 px-4 py-2 rounded-lg"
            >
              Yes
            </button>
            <button
              onClick={handleCloseSaveModal}
              className="bg-[#1C3664] text-white px-4 py-2 rounded-lg"
            >
              No
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default ViewManageProjectDetails;
